import { useContext, useEffect, useState } from "react";
import { AppContext } from "../../../AppProvider";
import { thingsBoardMicroserviceUrl } from "../../../../microservices/thingsboard_microservice";
import "../../../../styles/workspace_styles/TenantAdministratorStyles/Accounts/ServerConnections.css";
import { AccountContext } from "./AccountProvider";

const ServerConnections = () =>{
    const {user,userProfile,logout} = useContext(AppContext);
    const {
        showNewServerConnectionWindow,
        setShowNewServerConnectionWindow,
        selectedEditTenantAdminProfile,
        setSelectedEditTenantAdminProfile,
        selectedDeleteTenantAdminProfile,
        setSelectedDeleteTenantAdminProfile
    } = useContext(AccountContext);
    const [tenantAdminProfiles,setTenantAdminProfiles] = useState(null);
    const fetchServerProfiles = async() =>{
        try{
            const url = `${thingsBoardMicroserviceUrl}/tenants/profiles/all/get`;
            const response = await fetch(url,{
                method:'GET',
                headers:{
                    'Authorization':`Bearer ${user?.access_token}`,
                    'Content-Type':'application/json'
                }
            });
            if(response.status){
                const responseData = await response.json();
                setTenantAdminProfiles(responseData);
            }
            else if(Number(response.status) === 401) logout();
            else throw new Error(`response code: ${response.status}`);
        }
        catch(error){
            console.error('An error occurred when retrieving tenant administrator profiles from the server',error);
        }
    };
    useEffect(() =>{
        fetchServerProfiles();
    },[]);
    useEffect(() =>{
        if(showNewServerConnectionWindow && selectedEditTenantAdminProfile && selectedDeleteTenantAdminProfile) return;
        fetchServerProfiles();
    },[showNewServerConnectionWindow,selectedEditTenantAdminProfile,selectedDeleteTenantAdminProfile]);
    return(
        <div className="tenant-administrator-account-server-connections-container">
            <div className="header">
                <h1>Server connections</h1>
                <div className="minor-header">
                    <p>{userProfile?.firstName} {userProfile?.lastName}</p>
                    <button onClick={() => setShowNewServerConnectionWindow(true)}>Add Connection</button>
                </div>
            </div>
            <table>
                <thead>
                    <tr>
                        <th>Connection Name</th>
                        <th>Server Url</th>
                        <th>Username</th>
                        <th></th>
                    </tr>
                </thead>
                <tbody>
                    {tenantAdminProfiles && tenantAdminProfiles.map((tenantAdminProfile) =>(
                        <tr key={tenantAdminProfile?.id}>
                            <td>{tenantAdminProfile?.profileName}</td>
                            <td>{tenantAdminProfile?.serverUrl}</td>
                            <td>{tenantAdminProfile?.serverUsername}</td>
                            <td>
                                <button title="Edit connection"
                                    onClick={()=> setSelectedEditTenantAdminProfile(tenantAdminProfile)}>
                                    <img
                                        src={`${process.env.PUBLIC_URL}/images/edit-icon.png`}
                                    />
                                </button>
                                <button title="Delete connection"
                                    onClick={() => setSelectedDeleteTenantAdminProfile(tenantAdminProfile)}>
                                    <img
                                        src={`${process.env.PUBLIC_URL}/images/gray-bin-icon.png`}
                                    />
                                </button>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
};
export default ServerConnections;